import { axiosWithAuth } from "helpers";

export const paymentsService = {
	getPayoutsLists,
	getWithholdsLists,
	deleteWithholdPayment,
	saveWithholdAgent,
	saveWithholdMerchant,
	getMerchantMidName,
	getMerchantsForWithhold,
	getPayoutsAgents,
	updateDate,
	exportPayouts,
	getWithholdDetails,
	updateWithholdAgent,
	updateWithholdMerchant,
	completePayoutsReview,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

const PAGE_SIZE = 50;

function getPayoutsLists({
	paidMonth,
	paidYear,
	valueDate,
	page,
	filters,
	sortBy,
	isTotalWithhold = false,
}) {
	const businessUnit =
		filters?.businessUnit?.parent?.name || filters?.businessUnit?.name;

	const businessUnitHierarchy =
		filters?.businessUnit?.parent && filters?.businessUnit?.name;

	return axiosWithAuth({
		method: "GET",
		params: {
			page_size: PAGE_SIZE,
			page_index: page || 0,
			agent_office_id: filters?.agentOfficeDdl?.id || undefined,
			agent_name: filters?.agentName,
			payee_id: filters?.payeeId,
			partner_type: filters?.partnerType?.name,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			payment_method: filters?.paymentMethod?.name,
			value_date: valueDate,
			is_total_withhold: isTotalWithhold,
			sort_type: sortBy?.id ? sortBy?.id : undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/agent_payouts/${paidYear}/${paidMonth}`,
	});
}

function getWithholdsLists({
	paidMonth,
	paidYear,
	processingMonth,
	page,
	filters,
}) {
	const businessUnit =
		filters?.businessUnit?.parent?.name || filters?.businessUnit?.name;

	const businessUnitHierarchy =
		filters?.businessUnit?.parent && filters?.businessUnit?.name;

	return axiosWithAuth({
		method: "GET",
		params: {
			agent_office: filters?.agentOffice,
			partner_type: filters?.partnerType?.name,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			payee_id: filters?.payeeId,
			agent_name: filters?.agentName,
			merchant_id: filters?.merchantId,
			merchant_name: filters?.merchantName,
			source_type: filters?.sourceOfData?.name,
			processing_month: processingMonth,
			agent_withhold_reason: filters?.agentWithholdReason?.name,
			merchant_withhold_reason: filters?.merchantWithholdReason?.name,
			is_manual:
				filters?.isManual !== undefined
					? parseInt(filters?.isManual.value) === 1
					: undefined,
			page_size: PAGE_SIZE,
			page_index: page,
		},
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}`,
	});
}

function deleteWithholdPayment(paidMonth, paidYear, id) {
	const options = {
		method: "DELETE",
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}/${id}`,
	};
	return axiosWithAuth(options);
}

function saveWithholdAgent({ paidMonth, paidYear, values }) {
	const options = {
		method: "POST",
		data: {
			description: values?.description,
			is_status_update: values?.is_status_update,
			agent_id: values?.agent?.agent_id,
			withhold_reason: values?.withhold_reason?.name,
		},
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}/for_agent`,
	};
	return axiosWithAuth(options);
}

function saveWithholdMerchant({ paidMonth, paidYear, values }) {
	const options = {
		method: "POST",
		data: {
			description: values?.description,
			is_status_update: values?.is_status_update,
			merchant_id: values?.merchantValues?.id,
			withhold_reason: values?.withhold_reason?.name,
		},
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}/for_merchant`,
	};
	return axiosWithAuth(options);
}

function getMerchantMidName({
	paidMonth,
	paidYear,
	page = null,
	pattern = null,
	merchant_id = null,
	exclude_withheld = null,
}) {
	const isMidSearch = () => /^\d+$/.test(pattern);
	const isMerchantName = () => /^[a-zA-Z]+$/.test(pattern);

	return axiosWithAuth({
		method: "GET",
		params: {
			page_size: PAGE_SIZE,
			page_index: page,
			merchant_name: isMerchantName() ? pattern : null,
			mid: isMidSearch() ? pattern : null,
			merchant_id,
			exclude_withheld,
		},
		url: `${RESIDUALS_API_URL}/api/calculation_data/${paidYear}/${paidMonth}`,
	});
}

function getMerchantsForWithhold({
	paidMonth,
	paidYear,
	page = null,
	pattern = null,
}) {
	const isMidSearch = () => /^\d+$/.test(pattern);
	const isMerchantName = () =>
		/^[a-zA-Z\s!%:?*()_+-..,':@#$%&]+$/.test(pattern);

	return axiosWithAuth({
		method: "GET",
		params: {
			page_size: PAGE_SIZE,
			page_index: page,
			merchant_name: isMerchantName() ? pattern : null,
			mid: isMidSearch() ? pattern : null,
		},
		url: `${RESIDUALS_API_URL}/api/calculation_data/${paidYear}/${paidMonth}/merchants`,
	});
}

function getPayoutsAgents({ paidMonth, paidYear, page, pattern }) {
	return axiosWithAuth({
		method: "GET",
		params: {
			page_size: 10,
			page_index: page,
			agent_name: pattern,
		},
		url: `${RESIDUALS_API_URL}/api/agent_payouts/${paidYear}/${paidMonth}`,
	});
}

function updateDate({ paidMonth, paidYear, date }) {
	const options = {
		method: "POST",
		data: JSON.stringify(date),
		url: `${RESIDUALS_API_URL}/api/agent_payouts/${paidYear}/${paidMonth}/update_value_date`,
	};
	return axiosWithAuth(options);
}

function exportPayouts(paidMonth, paidYear) {
	try {
		let user = JSON.parse(localStorage.getItem("user") || "");
		const url = `${RESIDUALS_API_URL}/api/agent_payouts/${paidYear}/${paidMonth}/generate_report?download=true&token=${user.access_token}`;
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function getWithholdDetails({ paidYear, withholdId, paidMonth }) {
	return axiosWithAuth({
		method: "GET",
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}/${withholdId}`,
	});
}

function updateWithholdAgent({ paidYear, paidMonth, values }) {
	const options = {
		method: "PUT",
		data: {
			description: values?.description,
			is_status_update: values?.is_status_update,
			withhold_reason: values?.withhold_reason?.name,
		},
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}/for_agent/${values.withholdId}`,
	};
	return axiosWithAuth(options);
}

function updateWithholdMerchant({ paidYear, paidMonth, values }) {
	const options = {
		method: "PUT",
		data: {
			description: values?.description,
			is_status_update: values?.is_status_update,
			withhold_reason: values?.withhold_reason?.name,
		},
		url: `${RESIDUALS_API_URL}/api/withholds/${paidYear}/${paidMonth}/for_merchant/${values.withholdId}`,
	};

	return axiosWithAuth(options);
}

function completePayoutsReview({ paidYear, paidMonth }) {
	const options = {
		method: "POST",
		url: `${RESIDUALS_API_URL}/api/agent_payouts/${paidYear}/${paidMonth}/complete`,
	};

	return axiosWithAuth(options);
}
